import util from '@bmp-vue/core/api/util'

const controller = 'Autenticacao'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Autenticar: function (sender) {
    var dto = { Login: sender.email, Senha: sender.password }
    return util.Axios.Post(controller + '/AccessToken', dto)
  },
  Logout: function () {
    return util.Axios.Delete(controller + '/AccessToken')
  },
  RefreshToken: function (token) {
    var dto = { RefreshToken: token }
    return util.Axios.Post(controller + '/RefreshToken', dto)
  },
  RevokeRefreshToken: function (token) {
    return util.Axios.Delete(controller + 'RefreshToken', token)
  },
  SolicitarLinkSenha: function (dto) {
    dto.Login = dto.email
    return util.Axios.Post(controller + '/SolicitarLinkSenha', dto)
  },
  RecuperarSenha: function (dto) {
    return util.Axios.Post(controller + '/RecuperarSenha', dto)
  },
  ValidaTokenSenha: function (username, token) {
    const params = { username: username, token: token }
    return util.Axios.GetParams(controller + '/ValidaTokenSenha', params)
  },
  AtivarUsuario: function (username, token) {
    const params = { username: username, token: token }
    return util.Axios.GetParams(controller + '/AtivarUsuario', params)
  },
})
